// Text pre súbor, ktorý ešte nie je vo fronte enginu (23. 9. 2026).
export const waitText = (info) => {
  if (!info) return null;
  if (info.reason === 'slot') return 'Čaká na odoslanie – posielame najviac 5 súborov naraz.';
  if (info.reason === 'queue_full') {
    return `Fronta spracovania je plná – ďalší pokus o ${info.retryIn} s (pokus ${info.attempt} z ${info.max}).`;
  }
  return null;
};
